export const SectionIntro = {
  parts: ['Container', 'Intro', 'TipContainer', 'TipWord'],
  baseStyle: {
    Container: {
      margin: '48px auto 0px auto',
      textAlign: 'center',
    },
    Intro: {
      textAlign: 'center',
      color: 'brand.black',
      fontSize: '18px',
      margin: '0 auto',
    },
    TipContainer: {
      display: 'inline-block',
      fontSize: '14px',
      color: 'brand.grey',
      padding: '6px 20px',
      margin: '20px auto 0 auto',
      borderRadius: '40px',
      background: 'brand.lightgreen2',
    },
    TipWord: {
      fontWeight: 'bold',
      display: 'inline-block',
      marginRight: '0.3em',
    },
  },
};
